import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { fetchDemoRequest } from '@/api/demo';
import i18n from '@/i18n';
import { tryFetchDemo, fetchDemo, setDemo } from '../actions';
import { demo as selectDemo } from '../selectors';

const tryFetchDemoEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchDemo.match),
    withLatestFrom(state$),
    map(([{ payload }, state]) => {
      const demo = selectDemo(state);

      if (demo.title === i18n.t('LOADING')) {
        return fetchDemo(payload);
      }

      return {
        type: 'DEMO_ALREADY_FETCHED',
      };
    }),
  );

const fetchDemoEpic: Epic = (action$) =>
  action$.pipe(filter(fetchDemo.match), request(fetchDemoRequest, fetchDemo));

const fetchDemoSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDemo.succeeded.match),
    map(({ payload }) => setDemo(payload)),
  );

const fetchDemoFailedEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchDemo.failed.match),
    mergeMap(({ payload }) => [
      setDemo({ title: 'Error', description: payload }),
      openSnackbar({
        snackbarType: 'error',
        snackbarMessage: i18n.t('FETCH_DEMO_ERROR'),
      }),
    ]),
  );

export default combineEpics(
  tryFetchDemoEpic,
  fetchDemoEpic,
  fetchDemoSucceededEpic,
  fetchDemoFailedEpic,
);
